import { createUnifiedTheme, createBaseThemeOptions, palettes } from '@backstage/theme'

const commonOverrides = {
  BackstagePage: {
    styleOverrides: {
      root: {
        height: 'auto'
      }
    }
  }
}

export const customLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.light
  }),
  palette: {
    ...palettes.light,
    background: {
      default: '#f3f2f0',
      paper: '#ffffff'
    }
  },
  components: {
    ...commonOverrides,
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(even)': {
            backgroundColor: 'transparent'
          }
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          '& code': {
            backgroundColor: 'rgba(128, 70, 0, 0.05)',
            padding: '0 0.5ex',
            borderRadius: '3px'
          }
        }
      }
    }
  },
  defaultPageTheme: 'home'
})

export const customDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.dark
  }),
  palette: {
    ...palettes.dark,
    background: {
      default: '#202020',
      paper: '#121212'
    },
    divider: 'rgba(255, 255, 255, 0.15)',
    navigation: {
      background: '#333',
      indicator: '#9bf0e1',
      color: '#b5b5b5',
      selectedColor: '#ffffff',
      navItem: {
        hoverBackground: '#404040'
      }
    }
  },
  components: {
    ...commonOverrides,
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: '1px solid rgba(255, 255, 255, 0.2)'
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(even)': {
            backgroundColor: 'transparent'
          }
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          '& code': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            padding: '0 0.5ex',
            borderRadius: '3px',
            color: 'rgba(255, 255, 255, 0.9)'
          }
        }
      }
    }
  },
  defaultPageTheme: 'home'
})
